import { createAction } from "redux-actions";

export const USER_SELECTS_SECONDARY_AREA_FILTER_TYPE = "USER_SELECTS_SECONDARY_AREA_FILTER_TYPE";
export const userSelectsSecondaryAreaFilterType = createAction(USER_SELECTS_SECONDARY_AREA_FILTER_TYPE);

export const USER_SELECTS_SECONDARY_AREA_OPTION = "USER_SELECTS_SECONDARY_AREA_OPTION";
export const userSelectsSecondaryAreaOption = createAction(USER_SELECTS_SECONDARY_AREA_OPTION);

export const USER_SELECTS_SECONDARY_CATEGORY_FILTER_TYPE = "USER_SELECTS_SECONDARY_CATEGORY_FILTER_TYPE";
export const userSelectsSecondaryCategoryFilterType = createAction(USER_SELECTS_SECONDARY_CATEGORY_FILTER_TYPE);

export const USER_SELECTS_SECONDARY_CATEGORY_OPTION = "USER_SELECTS_SECONDARY_CATEGORY_OPTION";
export const userSelectsSecondaryCategoryOption = createAction(USER_SELECTS_SECONDARY_CATEGORY_OPTION);
